<template>
  <div class="pa-10">
    <CompanyRequestInternDataTable />
  </div>
</template>

<script>
import CompanyRequestInternDataTable from "@/components/Utils/CompanyRequestInternDataTable.vue";
export default {
  components: {
    CompanyRequestInternDataTable,
  },
  created() {
    if (this.$store.state.expiryDate < Date.now()) {
      this.$store.dispatch("setUser", null);
      this.$store.dispatch("setIsAuthenticated", 0);
      this.render = true;
      this.$router.push("/");
    }
  },
  data: () => ({
    typeData: [],
    action: null,
    reload: false,
  }),
  methods: {},
};
</script>

<style></style>
